import gql from 'graphql-tag';
import ShippingMethodAllFragment from '../fragments/ShippingMethodAllFragment';

export default gql`
query ShippingMethod($id: Int!) {
    adminShippingMethodById(id:$id) {
        ...ShippingMethodAllFragment
    }
}
${ShippingMethodAllFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminShippingMethod.ts